<template>
  <a-modal :visible="true" title="添加贝商" @ok="sub" @cancel="cancel">
    <a-form
      :label-col="formItemLayout.labelCol"
      :wrapper-col="formItemLayout.wrapperCol"
    >
      <a-form-item label="选择">
        <a-select
          show-search
          placeholder="选择贝商"
          option-filter-prop="children"
          style="width: 200px"
          :filter-option="filterOption"
          v-model="form.seller_id"
        >
          <a-select-option :value="0"> 请选择 </a-select-option>
          <a-select-option v-for="(seller, index) in sellerList" :key="index" :value="seller.id">{{seller.name}}</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="备注">
        <a-textarea
          v-model="form.remarks"
          :auto-size="{ minRows: 2, maxRows: 6 }"
        />
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<style lang='scss' scoped>
</style>

<script>
import moment from "moment";
export default {
  props: ["exh_id"],
  data() {
    return {
      formItemLayout: {
        labelCol: {
          span: 4,
        },
        wrapperCol: {
          span: 19,
        },
      },
      sellerList: [],
      form: {
        exh_id: null,
        seller_id: 0,
        remarks: ''
      },
    };
  },
  created() {
    this.form.exh_id = this.exh_id;
    this.getSellerList();
  },
  methods: {
    moment,
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },

    async getSellerList() {
      // 获取所有的资料分类
      const r = await this.$axios.get("/seller/getAllList");
      if (r.status == 1) {
        this.sellerList = r.list;
      }
    },

    async sub() {
      if (!this.form.exh_id) return this.$message.error("未找到贝展id");
      if (!this.form.seller_id) return this.$message.error("请选择贝商");

      const r = await this.$axios.post("/seller/bindExh", this.form);

      if (r.status == 1) {
        this.callback(true);
      }
    },

    cancel() {
      this.callback(false);
    },

    callback(e) {
      this.$emit("callback", e);
    },
  },
};
</script>